import { render, staticRenderFns } from "./ScoreData.vue?vue&type=template&id=607e3e80&scoped=true&"
import script from "./ScoreData.vue?vue&type=script&lang=js&"
export * from "./ScoreData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607e3e80",
  null
  
)

export default component.exports